module.exports = __webpack_public_path__ + "static/media/Nilesh-Shah.a5bd0482.png";